import { useNavigate } from "react-router-dom";
import cross from "../assets/cross.png";

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f8f9fb] flex flex-col items-center justify-center px-4 pt-[200px]">
      <div className="max-w-2xl mx-auto w-full mb-6"></div>
      <div className="w-full max-w-2xl bg-white rounded-xl shadow-md p-5 md:p-8 mt-4 text-center">
        <img
          src={cross}
          alt="Cancelled"
          className="w-[80px] h-[80px] mx-auto mb-6"
        />
        <h2 className="text-[28px] text-[#1e2b5e] mb-4 font-georgia">
          Payment Cancelled
        </h2>
        <p className="text-[#1B365D] mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>

        <div className="bg-[#fff8f0] border-l-4 border-[#F4A261] p-4 mb-6 text-left">
          <p className="text-[#1B365D] text-sm">
            <span className="font-semibold">Need help?</span> If you experienced
            any issues during checkout, please contact our support team or try
            again.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate("/subscription-package")}
            className="bg-[#F4A261] text-[#1B365D] border-2 border-[#F4A261] font-semibold px-8 py-3 rounded-[50px] text-xl hover:bg-[#F29449]"
          >
            Try Again
          </button>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-white text-[#1B365D] border-2 border-[#1B365D] font-semibold px-8 py-3 rounded-[50px] text-xl hover:bg-[#1B365D] hover:text-white"
          >
            Go to Dashboard
          </button>
        </div>

        <p className="text-sm text-gray-600 mt-6">
          Have questions?{" "}
          <a href="/contact-us" className="text-[#F4A261] hover:underline">
            Contact us
          </a>
        </p>
      </div>
    </div>
  );
};

export default PaymentCancelled;
